import './faq.scss'

( function( $ ) {

    $( document ).ready( function() {

        $( '.js-faqItem' ).on( 'click', function() {

            $( this ).toggleClass( '-active' );
            $( this ).next( '.m-faq__answer' ).slideToggle( 250 );

        } );
        
    } );

} )( jQuery );